import { render, staticRenderFns } from "./prize-draw-look.vue?vue&type=template&id=7f145523&scoped=true"
import script from "./prize-draw-look.vue?vue&type=script&lang=js"
export * from "./prize-draw-look.vue?vue&type=script&lang=js"
import style0 from "./prize-draw-look.vue?vue&type=style&index=0&id=7f145523&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f145523",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f145523')) {
      api.createRecord('7f145523', component.options)
    } else {
      api.reload('7f145523', component.options)
    }
    module.hot.accept("./prize-draw-look.vue?vue&type=template&id=7f145523&scoped=true", function () {
      api.rerender('7f145523', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/components/prize-draw-look.vue"
export default component.exports